<template>
  <div
    class="blaze-slider d-flex justify-center align-center"
    :class="[classElement, $vuetify.breakpoint.xs ? 'isMobile' : '']"
  >
    <v-container class="px-0">
      <div class="blaze-container">
        <v-btn
          v-if="!$vuetify.breakpoint.smAndDown && games.length > 0"
          class="prevNextButtons blaze-prev pa-0"
          text
          absolute
          style="
            top: calc(50% - 32px);
            left: -48px;
            z-index: 1;
            min-width: 40px;
          "
        >
          <v-icon size="32">mdi-chevron-left</v-icon>
        </v-btn>
        <div
          class="blaze-track-container"
          :class="{ 'px-5 pt-0': $vuetify.breakpoint.smAndDown }"
        >
          <div class="blaze-track">
            <div v-for="(game, index) in games" :key="index">
              <v-card
                class="cards d-flex flex-column"
                :style="{
                  'box-shadow': '0 0 0 1px rgba(255,255,255,0.1)',
                  'outline-offset': '-1px',
                  'border-radius': '8px',
                  backgroundImage: `url(https://cdn.softswiss.net/b/${
                    game.identifier_game.split(':')[0]
                  }/${game.identifier_game.split(':')[1]}.jpg)`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                  width: '99%',
                  height: '100%',
                }"
              >
                <!-- logo game -->
                <div
                  class="imageGameSlider"
                  style="padding: 24px 80px 0px 80px; width: 100%"
                  :style="{ height: `calc(${heightImageGame}px + 24px)` }"
                >
                  <v-skeleton-loader
                    v-show="loadingImage"
                    type="image"
                    :height="heightImageGame"
                    style="border-radius: 2rem"
                  ></v-skeleton-loader>
                  <img
                    v-show="!loadingImage"
                    width="100%"
                    :src="game.src"
                    :alt="game.title_game"
                    @load="loadingImage = false"
                    :style="{
                      'border-radius': '2rem',
                      'box-shadow': '0 0 0 1px rgba(255,255,255,0.2)',
                      'outline-offset': '-2px',
                    }"
                  />
                </div>
                <!-- logo provider -->
                <div class="mx-auto" style="margin-top: 8px; height: 24px">
                  <img
                    :width="game.provider_id === 'evoplay' ? '30px' : '56px'"
                    :src="
                      encodeURI(
                        `https://cdn.softswiss.net/logos/providers/white/${game.provider_id}.svg`.replace(
                          /\s/g,
                          ''
                        )
                      )
                    "
                    @click="allGamesProvider(game.id_provider)"
                    style="cursor: pointer;"
                  />
                </div>
                <!-- game title -->
                <div
                  class="
                    text-h5
                    text-center
                    text-truncate
                    font-weight-bold
                    py-1 px-2 my-1
                  "
                  :title="game.title_game"
                >
                  {{ game.title_game }}
                </div>
                <!-- Categorias -->
                <div class="d-flex flex-wrap justify-center align-start">
                  <template v-for="(category, index) in game.categories">
                    <v-chip
                      v-if="index < 3"
                      :key="category"
                      small
                      outlined
                      class="ml-1 mb-1"
                      @click="allGamesCategory(category)"
                    >
                      {{ category }}
                    </v-chip>
                  </template>
                </div>
                <!-- button play (jogar) -->
                <div class="d-flex flex-shrink-0 align-end flex-grow-1">
                  <div class="d-flex flex-grow-1 flex-shrink-0 pl-4">
                    <v-btn
                      class="mb-4 mt-2"
                      width="100%"
                      color="primary"
                      large
                      @click="gameClicked({ game, demo: false })"
                    >
                      <v-icon left size="24">mdi-play</v-icon>
                      {{ $t("play") }}
                    </v-btn>
                  </div>
                  <div class="d-flex flex-grow-0 pl-4 pr-4">
                    <v-btn
                      elevation="0"
                      class="mb-4 mt-2"
                      large
                      :style="{
                        minWidth: '50px',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                      }"
                      @click.stop="clickDetail(game)"
                    >
                      <v-icon color="grey lighten-3" size="24"
                        >mdi-information-outline</v-icon
                      >
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </div>
        <div v-show="games.length > 0" class="blaze-pagination"></div>
        <v-btn
          v-if="!$vuetify.breakpoint.smAndDown && games.length > 0"
          class="prevNextButtons blaze-next pa-0"
          text
          absolute
          style="
            top: calc(50% - 40px);
            right: -48px;
            z-index: 1;
            min-width: 40px;
          "
        >
          <v-icon size="32">mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-container>
    <ItemDialog
      :dialog="itemDialog"
      type="category"
      :categoryName="viewingItem.categoryName"
      :item="viewingItem"
      @closeItemDialog="closeItemDialog"
    />
  </div>
</template>
<script>
import ItemDialog from "../../views/home/casinoNew/components/item/itemDialog.vue";
export default {
  name: "BlazeSlider",
  props: ["classElement", "games"],
  components: { ItemDialog },
  data: () => ({
    loadingImage: true,
    itemDialog: false,
    viewingItem: false,
    dataImageGameDiv: {},
  }),

  mounted() {
    this.dataImageGameDiv = document.querySelector(".imageGameSlider");

    if (this.games.length > 0) {
      if (window.BlazeSlider) {
        document.querySelectorAll(".blaze-slider").forEach((el) => {
          new window.BlazeSlider(el, {
            all: {
              enableAutoplay: false,
              slidesToShow: 3,
              slidesToScroll: 3,
              transitionDuration: 300,
              stopAutoplayOnInteraction: true,
              loop: true,
            },
            "(max-width: 600px)": {
              enableAutoplay: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              slidesGap: "20px",
              transitionDuration: 400,
            },
          });
        });
      }
    }
  },

  computed: {
    heightImageGame() {
      // Buscando o width da div com a classe "imageGame" e subtraindo o padding
      const currentWidthImageGame = this.dataImageGameDiv.offsetWidth - 160;
      return currentWidthImageGame;
    },
  },

  methods: {
    clickDetail(item) {
      this.itemDialog = true;
      this.viewingItem = item;
    },
    closeItemDialog() {
      this.itemDialog = false;
      this.viewingItem = {};
    },
    allGamesProvider(providerId) {
      this.$router.push({
        name: "casinoProvider",
        params: { providerId },
      });
    },
    allGamesCategory(category) {
      this.$router.push({
        name: "casinoCategory",
        params: { category },
      });
    },
    // gameClicked({ game, demo }) {
    gameClicked({ game }) {
      // if (!this.$store.state.logged.status) {
      //   const casinoType = this.$route.params.casinoType;

      //   game.redirectUrl = `/casino/lobby/${casinoType}/category/${game.categoryName}/game/${game.game_id}`;
      //   game.redirectUrl += `?demo=${!!demo}`;

      //   this.$root.$emit("openUnloggedDialog", game);
      //   return;
      // }

      const params = {
        gameId: game.game_id,
        category: game.categoryName,
      };

      this.$router.push({
        name: "casinoGameCategory",
        params,
        // query: { demo },
      });
    },
  },
};
</script>
<style scoped>
.v-skeleton-loader.v-skeleton-loader--is-loading >>> .v-skeleton-loader__image {
  height: 100%;
}
/* CSS inicial do Blazer Slider  */
.blaze-slider {
  --slides-to-show: 1;
  --slide-gap: 20px;
  direction: ltr;
}
.blaze-container {
  position: relative;
}
.prevNextButtons {
  opacity: 0;
  transition: all 0.1s linear;
}
.blaze-container:hover .prevNextButtons {
  opacity: 1;
}
.prevNextButtons:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.blaze-track-container {
  overflow: hidden;
  padding: 8px 0 16px;
}

.blaze-track-container::-webkit-scrollbar {
  display: none;
}

.isMobile .blaze-track-container {
  overflow: auto;
}
.blaze-track {
  will-change: transform;
  touch-action: pan-y;
  display: flex;
  gap: var(--slide-gap);
  --slide-width: calc(
    (100% - (var(--slides-to-show) - 1) * var(--slide-gap)) /
      var(--slides-to-show)
  );
  box-sizing: border-box;
}
.blaze-track > * {
  box-sizing: border-box;
  width: var(--slide-width);
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.blaze-pagination {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.isMobile .blaze-pagination {
  width: 100vw;
}
.blaze-pagination >>> button {
  font-size: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  outline: none;
  border: none;
  background: rgba(255, 255, 255, 0.755);
  cursor: pointer;
  transition: transform 200ms ease, background-color 300ms ease;
  z-index: 1;
}
.blaze-pagination >>> button.active {
  background: var(--v-primary-base);
  transform: scale(1.3);
}

/* .cards {
  -webkit-box-shadow: 10px 10px 20px 5px #000000 !important;
  box-shadow: 10px 10px 20px 5px #000000a9 !important;
  transition: all linear 0.2s;
}
.isMobile .cards {
  -webkit-box-shadow: 0px 0px 15px 1px #000000 !important;
  box-shadow: 0px 0px 15px 1px #000000a9 !important;
  transition: all linear 0.2s;
} */
.cards::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
}
.cards > * {
  position: relative;
  z-index: 2;
}
</style>
